//@ts-nocheck



/**
 * Takes two arrays of numbers and returns a new array of tuples, where each tuple contains the corresponding elements from each array.
 * @param a An array of numbers
 * @param b An array of numbers
 * @returns An array of tuples, where each tuple contains the corresponding elements from `a` and `b`
 */
export const zip = (a: number[], b: number[]): [number, number][] => a.map((k, i) => [k, b[i]]);

/**
 * Calculates the Euclidean distance between two points in n-dimensional space, where `n` is the length of the input arrays.
 * @param ogn An array of numbers representing the coordinates of the first point.
 * @param dst An array of numbers representing the coordinates of the second point.
 * @returns The Euclidean distance between the two points in n-dimensional space.
 */
export const getEuclideanDistance = (ogn: number[] | number, dst: number[] | number): number => {
    if (Array.isArray(ogn) !== true) return Math.abs(ogn - dst);
    let zipped: [number, number][] = zip(ogn, dst);
    let summed: number = 0;
    for (let i = 0; i < zipped.length; i++) {
      let [x, y] = zipped[i];
      summed += (y - x) ** 2;
    }
    return Math.sqrt(summed);
  };



/**
 * Returns the directional movement trend between two positions. For 1 dimensional movement,
 * the function is fed a float, and for 2 or 3 dimensional movement, the function is fed an array
 * of floats.
 *
 * @param curr The current position, represented as either a single float or an array of floats.
 * @param prev The previous position, represented as either a single float or an array of floats.
 * @returns An array representing the movement trend between the two positions, where 1 indicates
 *          an increase in value, -1 indicates a decrease in value, and 0 indicates no change.
 */
export const getVectorTrends = (curr: number[] | number, prev: number[] | number): number[] => {
    let trend: number[] = [0, 0, 0];
    if (typeof curr === "number" || typeof prev === "number") {
        if (curr - prev > 0) {
        return [1];
        } else if (curr - prev < 0) {
        return [-1];
        } else {
        return [0];
        }
    }
    for (let i = 0; i < trend.length; i++) {
        const currVal = parseFloat(curr[i].toFixed(10));
        const prevVal = parseFloat(prev[i].toFixed(10));
    
        if (currVal > prevVal) {
          trend[i] = 1;
        } else if (currVal < prevVal) {
          trend[i] = -1;
        } else {
          trend[i] = 0;
        }
      }
    return trend
}

export const degreesToRadians = (degrees) => {
    return degrees * (Math.PI / 180);
}

export const getDistanceBetweenPoints2D = (x1, y1, x2, y2) => {
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
}

export function calculateIncomingVelocity(layerNum, time, prop): number {
    if (!time || !layerNum) return 1; //TODO: we need to get a "default" layer number or value here for the UI? maybe do in UI
    var delta = -0.03;
    var v1 = prop.valueAtTime(time + delta, true);
    var v2 = prop.valueAtTime(time + delta + delta, true);
    var velocity = new Array(v1.length)
    if(v1.length){
        var i;
        for(i=0;i<v1.length;i+=1){
            velocity[i] = (v2[i] - v1[i])/delta;
        }
    } else {
        velocity = (v2 - v1)/delta;
    }
    return velocity;
}

export const normalize = (vec) => {
return div(vec, length(vec));
}

function isInstanceOfArray(arr) {
return arr.constructor === Array || arr.constructor === Float32Array;
}

function isNumerable(tOfV, v) {
return tOfV === 'number' || tOfV === 'boolean' || tOfV === 'string' || v instanceof Number;
}

function div(a,b) {
let tOfA = typeof a;
let tOfB = typeof b;
let arr;
if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
    return a / b;
}
let i, len;
if(isInstanceOfArray(a) && isNumerable(tOfB, b)){
    len = a.length;
    arr = new Array(len);
    for(i=0;i<len;i+=1){
        arr[i] = a[i] / b;
    }
    return arr;
}
if(isNumerable(tOfA, a) && isInstanceOfArray(b)){
    len = b.length;
    arr = new Array(len);
    for(i=0;i<len;i+=1){
        arr[i] = a / b[i];
    }
    return arr;
}
return 0;
}

export const mapToValues = (val, multiplier) => {
    if (val instanceof Array) {
      let res = []
      for (let i = 0; i < val.length; i++) {
        res.push(val[i] * multiplier);
      }
      return res
    } else {
      return val * multiplier;
    }
  }
  
export const addArrayValues = (val1, val2) => {
    if (val1 instanceof Array) {
      let res = []
      for (let i = 0; i < val1.length; i++) {
        res.push(val1[i] - val2[i]);
      }
      return res
    } else {
      return val1 - val2;
    }
  }